import { type ChainflipNetwork } from '@chainflip/sdk/swap';

export const SWAPPING_APP_DOMAINS: Record<ChainflipNetwork, string> = {
  mainnet: 'swap.chainflip.io',
  perseverance: 'swap.perseverance.chainflip.io',
  sisyphos: 'swap.sisyphos.staging',
  backspin: 'swap.backspin.staging',
};
